<template>
    <BModal
      v-model="isVisible"
      :title="title"
      class="c-b-modal"
      :hide-footer="true"
      :hide-header-close="true"
      :no-close-on-backdrop="!clickToClose"
      :no-close-on-esc="!clickToClose"
    >
      <div class="mb-3 ml-3">{{ text }}</div>
      <div class="w-100 d-flex">
        <BButton
            v-for="(btn, index) in buttons"
            :key="index"
            :variant="btn.variant || ''"
            class="ms-2"
            @click="handleButtonClick(btn)"
          >
          {{ btn.title }}
        </BButton>
      </div>
    </BModal>
  </template>

<script setup>
import { ref, defineExpose } from 'vue'
import { BModal, BButton } from 'bootstrap-vue-next'

const isVisible = ref(false)
const title = ref('')
const text = ref('')
const buttons = ref([])
const clickToClose = ref(true)

function show (config) {
  title.value = config.title || ''
  text.value = config.text || ''
  buttons.value = Array.isArray(config.buttons) ? config.buttons : []
  clickToClose.value = config.clickToClose !== false
  isVisible.value = true
}

function hide () {
  isVisible.value = false
}

function handleButtonClick (btn) {
  if (typeof btn.handler === 'function') {
    btn.handler()
  }
  hide()
}

// expose methods so parent can control modal
defineExpose({
  show,
  hide
})
</script>

<style scss>
.c-b-modal {
  .modal-header {
    border: none;
    padding-bottom: 0;
  }
  .modal-content {
    padding: 0;
  }
  .modal-body {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    button {
      height: 40px;
      color: inherit;
      background: transparent;
      box-shadow: none;
      border: 1px solid #e0e0e0;
      flex: 1;
      border-radius: 0;
      border: 0;
      margin-left: 0;
      margin-right: 0;
      border-top: 1px solid #eee;

    }
    button:first-child {
      border-right: 1px solid #eee;
    }
    button:hover {
      background: #e0e0e0;
    }
    button:active {
      box-shadow: none;
      background: #e0e0e0;
    }
    button:focus {
      box-shadow: none;
      background: #e0e0e0;
    }
  }
}
</style>
